export default __webpack_public_path__ + "static/fa-solid-900-b1e216765b1f2b0a95b8235940522787.woff";